export class EligbilityIndicator {
    ID: number;
    Code: string;
    Name: string;
    Inactive?: boolean;
    FullName?: string;
}

export default EligbilityIndicator;